var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      value: _vm.chosenOption,
      multiple: _vm.multiple,
      options: _vm.postedAtOptions,
      placeholder: _vm.placeholder,
      customMultiStyleParent: _vm.getcontainerStyle,
      disabled: _vm.disabled,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }